export default __webpack_public_path__ + "static/media/transfersIcon.8350a1f2.svg";